import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EventHistoryLookupResponse } from './event-history.model';

/**
 * TVG-220: Client for the admin-only Event History Lookup endpoint. Posts up to
 * 10 hand-entered references and returns the full history for each, plus any
 * references that did not match an event.
 */
@Injectable({ providedIn: 'root' })
export class EventHistoryLookupService {
  private readonly baseUrl = `${environment.apiUrl}/api/event-history-lookup`;

  constructor(private http: HttpClient) {}

  lookup(references: string[]): Observable<EventHistoryLookupResponse> {
    return this.http.post<EventHistoryLookupResponse>(this.baseUrl, { references });
  }

  /**
   * TVG-222: Download the same resolved histories as a CSV. Posts the references
   * so the server rebuilds the file from the exact data shown on the page.
   */
  export(references: string[]): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/export`, { references }, { responseType: 'blob' });
  }
}
